import React from 'react';
import NextLink from 'next/link';

import { GalleryAddress } from '@definitions/artworks.types';
import { ROUTE } from '@utils/constants';
import { GALLERY_ADDRESS_BLOCK_TEST_ID } from '@components/galleryAddressBlock/galleryAddressBlock.constants';

import { Container, GalleryRow, GalleryName } from './galleryAddressBlock.styles';

export const GalleryAddressBlock = ({
  internalLink,
  name,
  slug,
  addressCity,
  addressCountry,
  addressStreet,
  addressStreet2,
}: GalleryAddress) => {
  const galleryLink = internalLink ? `/${internalLink}` : `${ROUTE.GALLERIES}/${slug}`;
  return (
    <NextLink href={galleryLink} passHref>
      <Container data-testid={`${GALLERY_ADDRESS_BLOCK_TEST_ID}-${name}`}>
        <GalleryName>{name}:</GalleryName>
        <GalleryRow>{addressStreet}</GalleryRow>
        <GalleryRow>{addressStreet2}</GalleryRow>
        <GalleryRow>{addressCity}</GalleryRow>
        <GalleryRow>{addressCountry}</GalleryRow>
      </Container>
    </NextLink>
  );
};
